import { store } from '@/firebase'
import {
  CollectionName,
  FSAuthorizedServiceAccount,
  OauthServiceName
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  doc,
  DocumentData
} from 'firebase/firestore'
export class AuthorizedServiceAccount {
  static doc(uid: string, serviceName: OauthServiceName, accountIndex: number) {
    return doc<FSAuthorizedServiceAccount, DocumentData>(
      this.collection(uid, serviceName),
      accountIndex.toString()
    )
  }

  static collection(uid: string, serviceName: OauthServiceName) {
    return collection(
      store,
      `${CollectionName.Users}/${uid}/${CollectionName.AuthorizedServices}/${serviceName}/${CollectionName.AuthorizedServicesAccounts}`
    ) as CollectionReference<FSAuthorizedServiceAccount>
  }
}
